enum ROUTES {
  HOME_PAGE = '/',
}

export default ROUTES;
